import { useEffect, useState } from "react";
import { useWindow } from "./useWindow";
const useBrowserSearchParams = (props) => {
    const myWindow = useWindow();
    const [searchParamsObj, setSearchParamsObj] = useState();
    const [urlHasParams, setUrlHasParams] = useState(false);
    const parseSearchParams = (searchParamsString) => {
        const searchParams = {};
        if (searchParamsString) {
            searchParamsString.split("&").forEach((param) => {
                const [key, value] = param.split("=");
                searchParams[decodeURIComponent(key)] = (props === null || props === void 0 ? void 0 : props.useMultiSelectFilters)
                    ? [...(searchParams[decodeURIComponent(key)] || []), ...[decodeURIComponent(value)]]
                    : decodeURIComponent(value);
            });
        }
        return searchParams;
    };
    const getInitialSearchParams = () => {
        const searchParamsString = myWindow.location.search.slice(1);
        const paramsObject = parseSearchParams(searchParamsString);
        setSearchParamsObj(paramsObject);
    };
    useEffect(() => {
        if (myWindow) {
            getInitialSearchParams();
            setUrlHasParams(myWindow.location.search !== "");
        }
    }, [myWindow]);
    const toggleSearchParamsInURL = (paramName, paramValue) => {
        const searchParamsString = myWindow.location.search.slice(1);
        const searchParams = parseSearchParams(searchParamsString);
        if (searchParams.hasOwnProperty(paramName) && searchParams[paramName] === paramValue) {
            delete searchParams[paramName];
        }
        else {
            searchParams[paramName] = paramValue;
        }
        const newSearch = Object.entries(searchParams)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join("&");
        const newURL = `${myWindow.location.pathname}${newSearch ? `?${newSearch}` : ""}${myWindow.location.hash}`;
        myWindow.history.replaceState(null, "", newURL);
    };
    const setMultiSelectSearchParamsInURL = (filterValues) => {
        const paramsArray = [];
        Object.entries(filterValues).forEach(([name, value]) => {
            if (Array.isArray(value)) {
                if (value.length === 0) {
                    return;
                }
                value.forEach((item) => {
                    paramsArray.push(`${encodeURIComponent(name)}=${encodeURIComponent(item)}`);
                });
            }
        });
        const newSearch = paramsArray && paramsArray.length !== 0 ? `?${paramsArray.join("&")}` : "";
        const newURL = `${myWindow.location.pathname}${newSearch}${myWindow.location.hash}`;
        myWindow.history.replaceState(null, "", newURL);
    };
    return {
        getInitialSearchParams,
        toggleSearchParamsInURL,
        setMultiSelectSearchParamsInURL,
        urlHasParams,
        searchParamsObj,
        myWindow
    };
};
export default useBrowserSearchParams;
